import { Box, Button, Flex, Image, Link, Text } from "@chakra-ui/react";
import { MdDoubleArrow, MdOutlineDoubleArrow } from "react-icons/md";

import { Rating } from "@/components/Rating";

import Router from "next/router";
import { useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

type CarouselProductsprops = {
  title?: string;
  color?: string;
};

type Product = {
  img: string;
  url: string;
  title: string;
  model: string;
  price: string;
  reviews: number;
  rating: number;
  categoryImage?: string;
  generalGrade?: number;
  reviewCount?: number;
};

function ArrowProductsPrev(props) {
  const { className, style, onClick } = props;
  return (
    <MdOutlineDoubleArrow
      className={className}
      style={{
        ...style,
        display: "block",
        margin: " 0",
        color: "#0766c7 !important",
        transform: "rotateY(180deg) translateY(-10px)"
      }}
      onClick={onClick}
    />
  );
}

function ArrowProductsNext(props) {
  const { className, style, onClick } = props;
  return (
    <MdDoubleArrow
      className={className}
      style={{
        ...style,
        display: "block",
        margin: "0",
        color: "#0766c7 !important"
      }}
      onClick={onClick}
    />
  );
}

export function CarouselProductsRelease({ title, color }: CarouselProductsprops) {
  const [ListProducts, setListProducts] = useState<Product[]>([]);

  const settings = {
    arrows: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    centerMode: false,
    nextArrow: <ArrowProductsNext />,
    prevArrow: <ArrowProductsPrev />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrow: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const renderSlides = () =>
    ListProducts.map((slide, index) => (
      <Flex key={index} h="full" w={["full", "320px"]} mt={["0", "20px"]}>
        <Flex justify="center">
          <Link
            _hover={{ textDecoration: "none" }}
            width="100%"
            mb="15px"
            //passHref

            href={null}
            onClick={() => {
              Router.push(`https://www.pneufree.com.br/linglong/${slide.url}`);
            }}
            _focus={{ boxShadow: "none" }}
          >
            <Flex
              w={["full", "380px"]}
              h="220px"
              direction="row"
              justify="center"
              alignItems="center"
              bg="white"
              border="1px solid"
              mb="0"
              borderColor="gray.100"
            >
              <Image
                src={slide.img}
                alt={slide.model}
                loading="lazy"
                w="140px"
                alignItems="center"
                // justify="center"
              />
              <Flex direction="column">
                <Text textStyle="MRegular" fontSize="text1" color="gray.700">
                  PNEU
                </Text>
                <Text fontSize={["h4", "h3"]} color="gray.700" textStyle="MBold">
                  {slide.title}
                </Text>
                <Text textStyle="MBold" fontSize="text1" color="blue.900">
                  {slide.model}
                </Text>
                <Box>
                  <Rating generalGrade={slide.rating} reviewCount={slide.reviews} />
                </Box>

                <Button
                  my="16px"
                  fontSize="text3"
                  textStyle="MBold"
                  colorScheme="green"
                  w={["130px", "180px"]}
                  h="30px"
                  borderRadius="0"
                  _focus={{ border: "none" }}
                >
                  VER DETALHES
                </Button>
              </Flex>
            </Flex>
          </Link>
        </Flex>
      </Flex>
    ));

  return (
    <></>
    // <Box
    //     mt={["20px", "20px"]}
    //     maxW="1200px"
    //     w="full"
    //     justifyContent="center"
    // >
    //     <Center
    //         mb="0.5rem"
    //         mt="1rem"
    //         textStyle="MBold"
    //         color={color}
    //         fontSize="h4"
    //     >
    //         {title}
    //     </Center>
    //     <Slider {...settings}>{renderSlides()}</Slider>
    // </Box>
  );
}
